import { HttpClientModule } from '@angular/common/http';
import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { AppComponent } from './app.component';
import { ApiService, CrudService, CancellableCrudService } from './services';
import { ErrorHandlerService } from './services/handlers';
import { Common2Module } from 'projects/common/src/app/app.module';
import { DomErrorInterceptorService, ErrorInterceptorService } from './services/interceptors';

const providers = [
  ApiService,
  CrudService,
  CancellableCrudService,
  ErrorInterceptorService,
  DomErrorInterceptorService,
  {
    provide: ErrorHandler,
    useClass: ErrorHandlerService,
  }
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    HttpClientModule,
    Common2Module.forRoot(),
  ],
  providers,
  bootstrap: [AppComponent]
})
export class AppModule { }


@NgModule({})
export class CommunicationModule {
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule,
      providers,
    };
  }
}
